export const returnToSender = 'return-to-render';
export const convertToSubAction = 'convert-to-subaction';
export const showCopyModal = 'show-copy-modal';
export const showRepeatModal = 'show-repeat-modal';
export const convertToAi = 'convert-to-action-item';
export const giveBadge = 'give-badge';
export const showMeetingsModal = 'show-meetings-dialog';
export const show1on1Modal = 'show-1on1-dialog';
export const showRemindMeModal = 'show-remind-modal';
export const showMirrorAiModal = 'show-mirror-modal';
export const pingForStatus = 'ping-for-status';
export const showDeleteAiModal = 'show-delete-modal';
export const pushToIntegration = 'push-to-integration';
export const requestFeedback = 'request-feedback';
